<header class="topbar">
  <div class="topbar-inner">

    <a class="brand" [routerLink]="homeRoute">
      <img alt="site logo" src="logo-white.svg" />
      <span class="brand-text">Vertical Talent</span>
    </a>

    <!-- Small screens: back arrow + page name replace the logo -->
    <button *ngIf="showBack" type="button" class="back-button" (click)="goBack()" aria-label="Back" title="Back">
      <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" fill="currentColor"/>
      </svg>
    </button>
    <div class="page-title">{{pageTitle}}</div>

    <!-- Primary links, inline on wide screens -->
    <nav class="primary-nav">
      <a *ngFor="let item of primaryItems"
         class="nav-link"
         [routerLink]="item.route"
         [queryParams]="item.queryParams"
         routerLinkActive="active">
        <img class="nav-icon" alt="" [src]="item.icon" />
        <span>{{item.label}}</span>
      </a>
    </nav>

    <div class="topbar-right">

      <!-- User chip opens the secondary menu (Account / Settings / FAQ / Help / Exit) -->
      <button type="button" class="user-chip" (click)="toggleUserMenu()"
              [class.open]="userMenuOpen" aria-haspopup="true" [attr.aria-expanded]="userMenuOpen">
        <img *ngIf="user?.picture" class="user-avatar" alt="profile image" [src]="user.picture" />
        <span *ngIf="user" class="user-name">{{user.firstName}} {{user.lastName}}</span>
        <span class="caret"></span>
      </button>

      <!-- Small screens: everything behind one button -->
      <button type="button" class="hamburger" (click)="toggleMobileMenu()"
              [class.open]="mobileMenuOpen" aria-label="Menu" [attr.aria-expanded]="mobileMenuOpen">
        <span></span><span></span><span></span>
      </button>

      <div class="dropdown" *ngIf="userMenuOpen">
        <div *ngIf="user" class="dropdown-user">
          <img *ngIf="user.picture" alt="profile image" [src]="user.picture" />
          <div class="user-detail">
            <h3>{{user.firstName}} {{user.lastName}}</h3>
            <span>{{UserRole[user.role]}}</span>
          </div>
        </div>
        <ng-container *ngFor="let section of secondarySections">
          <div class="menu-section-title">{{section.sectionTitle}}</div>
          <a *ngFor="let item of section.items"
             class="menu-link"
             [routerLink]="item.route"
             [queryParams]="item.queryParams"
             (click)="closeAll()">
            <img class="nav-icon" alt="" [src]="item.icon" />{{item.label}}
          </a>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Small-screen panel: drops straight down from the bar, never in from the side -->
  <div class="mobile-panel" *ngIf="mobileMenuOpen">
    <div *ngIf="user" class="dropdown-user">
      <img *ngIf="user.picture" alt="profile image" [src]="user.picture" />
      <div class="user-detail">
        <h3>{{user.firstName}} {{user.lastName}}</h3>
        <span>{{UserRole[user.role]}}</span>
      </div>
    </div>
    <ng-container *ngFor="let section of menuData.sections">
      <div class="menu-section-title">{{section.sectionTitle}}</div>
      <a *ngFor="let item of section.items"
         class="menu-link"
         [routerLink]="item.route"
         [queryParams]="item.queryParams"
         routerLinkActive="active"
         (click)="closeAll()">
        <img class="nav-icon" alt="" [src]="item.icon" />{{item.label}}
      </a>
    </ng-container>
  </div>
</header>
